import app from 'flarum/forum/app';

app.initializers.add('huseyinfiliz-flagify', () => {
    console.log('[Flagify] Extension initialized');
});
